import React from 'react';
import Icon from "components/elements/Icon";
import cn from "classnames";
import useRouter from "components/hooks/useRouter";
import useTrans from "components/hooks/useTrans";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

type Props = {
    isMobile: boolean;
};

export default function Share(props: Props) {
    const { t } = useTrans();
    const hrefAfterWindowisDefined = typeof window !== "undefined" ? `${window.location.href}` : '';
    const containerCn = cn(
        { "hidden lg:inline-block": !props.isMobile },
        { "inline-block lg:hidden": props.isMobile }
    );

    const titleCn = cn(
        "text-purple-tint-dark font-normal text-sm tracking-widest hidden lg:inline-block uppercase",
    );

    return (
        <div className={containerCn}>
             <span className={titleCn}>
                 {t('share')}
            </span>
            <div className={"flex gap-x-4 mt-3"}>
                <TwitterShareButton url={hrefAfterWindowisDefined} id={"share--twitter"}>
                    <Icon
                        url={"/static/icons/twitter.svg"}
                        className={'bg-purple-tint-dark h-5 w-5 hover:bg-purple'}
                    />
                </TwitterShareButton>

                <FacebookShareButton url={hrefAfterWindowisDefined} id={"share--facebook"}>
                    <Icon
                        url={"/static/icons/facebook.svg"}
                        className={'bg-purple-tint-dark h-5 w-5 hover:bg-purple'}
                    />
                </FacebookShareButton>

                <LinkedinShareButton url={hrefAfterWindowisDefined} id={"share--linkedin"}>
                    <Icon
                            url={"/static/icons/linkedin.svg"}
                            className={'bg-purple-tint-dark h-5 w-5 hover:bg-purple'}
                    />
                </LinkedinShareButton>

                <button className={"ga__button"} onClick={() => navigator.clipboard.writeText(hrefAfterWindowisDefined)} id={"share--clipped"}>
                    <Icon
                        url={"/static/icons/clipped.svg"}
                        className={'bg-purple-tint-dark h-5 w-5 hover:bg-purple'}
                    />
                </button>
            </div>
        </div>
    );
}